import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { CreateUpdateClientDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { FormRow66 } from '../../../app/components/FormRow';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ClientVindicationProps {
  client: CreateUpdateClientDto;
  propertyChange?: (obj: Partial<CreateUpdateClientDto>) => void;
  readonly?: boolean;
}

export const ClientVindication: React.FC<ClientVindicationProps> = ({
  client,
  propertyChange,
  readonly = false,
}) => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <Form className="d-grid gap-4 mb-4 mt-4">
      <Row>
        <Col md={6}>
          <FormRow66
            controlId="overduePaymentReminder"
            label={t(tk.client.overduePaymentReminder)}
          >
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.overduePaymentReminder ?? true}
              onChange={e =>
                propertyChange?.({
                  overduePaymentReminder: e.target.checked,
                })
              }
              disabled={readonly}
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="paymentRequest"
            label={t(tk.client.paymentRequest)}
          >
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.paymentRequest ?? true}
              onChange={e =>
                propertyChange?.({ paymentRequest: e.target.checked })
              }
              disabled={readonly}
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66
            controlId="paymentRequestKRD"
            label={t(tk.client.paymentRequestKRDfull)}
          >
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.paymentRequestKRD ?? true}
              onChange={e =>
                propertyChange?.({
                  paymentRequestKRD: e.target.checked,
                })
              }
              disabled={readonly}
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="paymentRequestBlockKRD"
            label={t(tk.client.paymentRequestBlockKRDFull)}
          >
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.paymentRequestBlockKRD ?? true}
              onChange={e =>
                propertyChange?.({
                  paymentRequestBlockKRD: e.target.checked,
                })
              }
              disabled={readonly}
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="interest" label={t(tk.client.interest)}>
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.interest ?? false}
              onChange={e =>
                propertyChange?.({
                  interest: e.target.checked,
                })
              }
              disabled={readonly}
            />
          </FormRow66>
        </Col>
      </Row>
    </Form>
  );
};
